import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Button } from "@mui/material";

const useStyles = makeStyles((theme) => ({
    popup: {
        padding: theme.spacing(2)
    }
}));

// export const widgetNames = {
//     a: "Threshold Breaches",
//     b: "Patient Cycle Activity",
//     c: "List of Patients",
//     d: "Latest 10 Readings",
//     e: "Rewards Program",
//     f: "Schedule Messages"
// };

export default function AddList({
    items,
    onRemoveItem,
    onAddItem,
    originalItems,
    allItems
}) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    const handleChange = (e) => {
        if (e.target.checked) {
            onAddItem(e.target.id);
        } else {
            onRemoveItem(e.target.name);
        }
    };

    return (
        <>
            <Button
                aria-describedby={id}
                onClick={handleClick}
                variant='contained'
                startIcon={<AddCircleOutlineIcon />}>
                Add / Edit
            </Button>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
            >
                <div className={classes.popup}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Select Widgets</FormLabel>
                        <FormGroup>
                            {allItems && allItems?.map((i) => {

                                return <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={originalItems?.some(
                                                (c) => {
                                                    return c.i === i.i
                                                }
                                            )}
                                            onChange={handleChange}
                                            name={i.i}
                                            id={i.component.id.toString()}
                                        />
                                    }
                                    label={i.component.displayName}
                                    key={i.component.id}
                                />

                            }
                            )}
                        </FormGroup>
                    </FormControl>
                </div>
            </Popover>
        </>
    );
}
